import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home/Home.jsx';
import About from './pages/About/About.jsx';
import PartnerWithUs from './pages/PartnerWithUs/PartnerWithUs.jsx';
import './styles/index.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
          <Route path="/partner-with-us" element={<PartnerWithUs />} />
      </Routes>
    </Router>
  );
}

export default App;
